import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import type { ReactElement, ReactNode } from "react";
import styles from "./Tooltip.module.css";

/** Shared delays: the first tooltip waits, neighbours open instantly (Base UI marks them data-instant). */
export function TooltipProvider({ children }: { children: ReactNode }) {
  return (
    <BaseTooltip.Provider delay={600} closeDelay={0} timeout={400}>
      {children}
    </BaseTooltip.Provider>
  );
}

export interface TooltipProps {
  /** The tooltip text: a full value behind an ellipsis, an absolute date, a disabled reason. */
  content: ReactNode;
  /** One focusable element (button, link, or an element with tabIndex) that triggers the tooltip. */
  children: ReactElement;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  disabled?: boolean;
}

/** Supplementary text on hover and focus; dismissible with Escape and hoverable. Never the only label. */
export function Tooltip({ content, children, side = "top", align = "center", disabled }: TooltipProps) {
  if (disabled || content === null || content === undefined || content === "") return children;
  return (
    <BaseTooltip.Root>
      <BaseTooltip.Trigger render={children} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner side={side} align={align} sideOffset={6} collisionPadding={8}>
          <BaseTooltip.Popup className={styles.popup}>{content}</BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  );
}
